import { Link } from "react-router-dom";
import Button from "../components-ui/Button/Button";
import styles from "./Unauthorized.module.css";

export default function Unauthorized() {
  return (
    <div className={styles.container}>
      <h1>⚠️ Erro! Você não tem autorização para acessar essa página.</h1>
    </div>
  );
}
